import React from "react";
import { Avatar, Heading, VStack } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import imageSelf from "../images/550689467_17898211707282177_2562119757305783862_n (1).jpg";

const greeting = "Hello, I am Ahmad!";
const bio1 = "A frontend developer";
const bio2 = "specialised in React";

// Implement the UI for the LandingSection component according to the instructions.
// Use a combination of Avatar, Heading and VStack components.
const LandingSection = () => (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground
    backgroundColor="#34d399"
    overflow="hidden"
  >
    <VStack spacing={4}>
      <div style={{ textAlign: "center" }}>
        <VStack  spacing={4}>
          <Avatar
            size="2xl"
            src={imageSelf}
            width={200}
            height={200}
          >
          </Avatar>
          <p>{greeting}</p>
        </VStack>
      </div>
      <div>
        <VStack spacing={4} align="center">
          <Heading as="h1" size="2xl">
            {bio1}
          </Heading>
          <Heading as="h2" size="xl">
            {bio2}
          </Heading>
        </VStack>
      </div>
    </VStack>
  </FullScreenSection>
);

export default LandingSection;
